module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAAXNSR0IArs4c6QAAADNQTFRFAAAAAP+AMbp/LbyHL7iCL7aEMbaDMLSCMbaDL7aDL7WEL7WEMLWDMLWEL7aEMLWDMLaEgfdyhAAAABF0Uk5TAAIaIitmfYWIjI2Rpbq8xNFTdGPcAAAAQElEQVQY02NgoDdgEuDAFOPn5eHEEGPhZmHjQhdj4GZhQBXlY2EACTKwsSIJMjJABMEMZAAWZCBbkJ2Z7gHGAAATSgEq31IbBAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/open/home_icon_arrow_litre.png
// module id = FqJR
// module chunks = 0